function setCategorySubmitted(item_id) {
  return fetch(`${process.env.REACT_APP_API_ENDPOINT}/category-changes`, {
    method: 'POST',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      item_id: `${item_id}`,
    },
  })
    .then((response) => response.json())
    .then((responseJSON) => {
      return responseJSON;
    });
}

export default setCategorySubmitted;
